export const getQuestionarieList = {
  screen: "QuestionarieScreen",
  sections: "getQuestionarieList",
  orgId : "a3fe60fe-3f6f-11ee-be56-0242ac120002"
};

export const getDocumentList = {
  sections: "getDocumentList",
  screen: "QuestionarieScreen",
  orgId : "a3fe60fe-3f6f-11ee-be56-0242ac120002"
};


export const getMappingList = {
  sections: "getMappedDocumentList",
  screen: "QuestionarieScreen",
  orgId : "a3fe60fe-3f6f-11ee-be56-0242ac120002"
};

export const getCategoriesByQuestioanrieId = {
  sections: "getCategoriesByQuestioanrieId",
  screen: "QuestionarieScreen",
  questionarieId: 12,
  isJsonReturnObject: false,
};

export const getQuestionarieTypes = {
  sections: "getQuestionarieTypes",
  screen: "QuestionarieScreen",
  isJsonReturnObject: false,
};

// get document details
export const getDocumentDetailsSections = {
  "sections": "getDocumentDetails",
  "screen": "QuestionarieManager",
  "isJsonReturnObject": true,
  "isJsonQuery": true
}

// get document images
export const getImageDataSections = {
  "sections": "getImageData",
  "screen": "QuestionarieManager",
  "isJsonReturnObject": true,
  "isJsonQuery": true
}

// get document fields - change isRead based on document status
export const getDocumentFieldsMappingSections = {
  "sections": "getDocumentFieldsMapping",
  "screen": "QuestionarieManager",
  // "isRead": false,
  "isJsonReturnObject": true,
  "isJsonQuery": true
}